import React, { useState } from "react";
import "./NewNameRegistration.css";

const NewNameRegistration = ({ onSave, onBack }) => {
  const [form, setForm] = useState({
    name: "",
    isDead: false,
    spouseName: "",
    mobile: "",
    heirName: "",
    aadhar: "",
    pan: ""
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value
    });
  };

  const handleSubmit = () => {
    if (!form.name.trim()) {
      alert("नाव भरणे आवश्यक आहे");
      return;
    }
    onSave(form);
    setForm({
      name: "",
      isDead: false,
      spouseName: "",
      mobile: "",
      heirName: "",
      aadhar: "",
      pan: ""
    });
  };

  return (
    <div className="new-name-registration-container">
      <div className="header">नवीन नाव नोंदणी</div>

      <div className="form-wrapper">
        <div className="form-box">
          <div className="field">
            <label>
              नाव <span className="req">*</span>
            </label>
            <input
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="पूर्ण नाव दाखल करा"
            />
          </div>

          <div className="checkbox">
            <input
              type="checkbox"
              id="isDead"
              name="isDead"
              checked={form.isDead}
              onChange={handleChange}
            />
            <label htmlFor="isDead" className="checkbox-label">मयत</label>
          </div>

          <div className="field">
            <label>पत्नीचे नाव</label>
            <input
              type="text"
              name="spouseName"
              value={form.spouseName}
              onChange={handleChange}
              placeholder="पत्नीचे नाव दाखल करा"
            />
          </div>

          <div className="field">
            <label>मोबाईल नंबर</label>
            <input
              type="tel"
              name="mobile"
              value={form.mobile}
              onChange={handleChange}
              placeholder="10 अंकांचा क्रमांक"
            />
          </div>

          <div className="field">
            <label>वारसदाराचे नाव</label>
            <input
              type="text"
              className="disabled"
              name="heirName"
              value={form.heirName}
              onChange={handleChange}
              disabled
              placeholder="स्वयंचलित भरणे"
            />
          </div>

          <div className="field">
            <label>आधार कार्ड क्रमांक</label>
            <input
              type="text"
              name="aadhar"
              value={form.aadhar}
              onChange={handleChange}
              placeholder="12 अंकांचा क्रमांक"
            />
          </div>

          <div className="field">
            <label>पॅन कार्ड क्रमांक</label>
            <input
              type="text"
              name="pan"
              value={form.pan}
              onChange={handleChange}
              placeholder="10 वर्णांचा कोड"
            />
          </div>
        </div>
      </div>

      <div className="btns">
        <button className="btn btn-save" onClick={handleSubmit}>
          जतन करा
        </button>
        <button className="btn btn-list" onClick={onBack}>
          नावांची यादी
        </button>
      </div>
    </div>
  );
};

export default NewNameRegistration;
